/**
 * Utilitaires centralisés pour la redirection
 * Toute la logique de redirection doit passer par ce fichier
 */

/**
 * Retourne le chemin attendu selon le rôle de l'utilisateur
 * @param {string} role - Rôle de l'utilisateur (normalisé)
 * @returns {string} Chemin attendu
 */
export function getExpectedPathByRole(role) {
  if (!role) return null;
  
  const normalizedRole = role.toString().trim().toLowerCase().replace(/_/g, '-');
  
  if (normalizedRole === 'super-admin') {
    return '/super-admin';
  }
  
  if (normalizedRole === 'freelancer') {
    return '/missions';
  }
  
  // Pour les teams (team-admin, team-member)
  return '/freelancers';
}

/**
 * Vérifie si l'utilisateur est déjà sur la route appropriée pour son rôle
 * @param {string} currentPath - Chemin actuel
 * @param {string} role - Rôle de l'utilisateur
 * @returns {boolean}
 */
export function isOnCorrectRoute(currentPath, role) {
  const expectedPath = getExpectedPathByRole(role);
  if (!expectedPath) return false;
  
  // Vérifier si on est sur la route exacte ou une sous-route
  return currentPath === expectedPath || currentPath.startsWith(expectedPath + '/');
}

/**
 * Redirige l'utilisateur vers la page appropriée selon son rôle
 * Évite les redirections inutiles si l'utilisateur est déjà sur la bonne route
 * 
 * @param {Function} navigate - Fonction navigate de react-router-dom
 * @param {string} role - Rôle de l'utilisateur (freelancer, team-member, team-admin, super-admin)
 * @param {object} options - Options de navigation (replace, state, etc.)
 * @param {string} currentPath - Chemin actuel (optionnel, pour éviter les redirections inutiles)
 */
export function redirectByRole(navigate, role, options = {}, currentPath = null) {
  if (!role) {
    return;
  }
  
  const defaultOptions = { replace: true, ...options };
  const normalizedRole = role.toString().trim().toLowerCase().replace(/_/g, '-');
  
  // ✅ Éviter les redirections inutiles si on est déjà sur la bonne route
  if (currentPath) {
    const expectedPath = getExpectedPathByRole(normalizedRole);
    if (expectedPath && (currentPath === expectedPath || currentPath.startsWith(expectedPath + '/'))) {
      return;
    }
  }
  
  let targetPath = null;
  
  // Si super-admin, rediriger vers /super-admin
  if (normalizedRole === 'super-admin') {
    targetPath = '/super-admin';
  }
  // Si freelancer, rediriger vers /missions
  else if (normalizedRole === 'freelancer') {
    targetPath = '/missions';
  }
  // Sinon, rediriger vers /freelancers pour les teams
  else {
    targetPath = '/freelancers';
  }
  
  navigate(targetPath, defaultOptions);
}
